import Helper from "./Helper";

class Anchor {
  constructor(config = {}) {
    const {
      anchorId
    } = config;
    this.anchorId = anchorId;
    this.headerHeight = document.querySelector('.header').clientHeight;

    if (!this.anchorId) {
      let anchors = document.querySelectorAll('.ns-link--anchor');

      anchors = Array.prototype.slice.call(anchors);

      // get navigation links
      let navigationLinks = document.querySelectorAll('.menu-main__link--level-1');
      navigationLinks.forEach((navLink, index) => {
        let navId = "";
        if (navLink.href.includes(location.pathname)) {
          navId = navLink.href.replace(location.origin, "").replace(location.pathname, "").split("#");
          
          if (navId[0] == "" && navId[1] != "") {
            anchors.push(navLink);
          }
        }
      });

      if (anchors) {
        this.bindEvents(anchors);
      }
    } else {
      this.scroll(this.anchorId);
    }

    
  }

  bindEvents(anchors) {
    this.bindClick(anchors);
  }

  bindClick(anchors) {
    anchors.forEach(item => {
      item.addEventListener('click', (e) => {
        e.preventDefault();

        const targetUrl = item.getAttribute('href');
        const targetId = targetUrl.split('#')

        this.scroll(targetId[1]);
        
        if (item.classList.contains("menu-main__link")) {
          let parentMenu = item.closest('.menu-main.active');
    
          if (parentMenu) {
            parentMenu.classList.remove('active');
          }
        }

        return false;
      });
    });
  }

  scroll(targetId) {
    const yOffset = this.headerHeight;
    const targetID = document.getElementById(targetId);
    const y = targetID.getBoundingClientRect().top + window.pageYOffset - yOffset;
    
    window.scrollTo({
      top: y,
      behavior: 'smooth'
    });
  }
}

export default Anchor;
